/* eslint-disable react/no-danger */
import {css, view, createView} from '@sail/ui';
import {renderMarkdown} from '../../helpers/markdown';
import {secondaryLinkStyles} from '../../helpers/style-intents';

export const MarkdownText = createView(({body, ...props}: {body: string}) => {
  const renderFn = renderMarkdown;

  return (
    <view.div
      {...props}
      data-testid="markdown-text"
      className="uh-live-answers-v2-text-body"
      css={{
        stack: 'y',
        gap: 'medium',
        wordBreak: 'break-word',
      }}
      uses={[
        secondaryLinkStyles('.uh-live-answers-v2-text-body'),
        css.global({
          '.uh-live-answers-v2-text-body p': {
            marginTop: '4px',
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body p:first-of-type': {
            marginTop: 0,
          },
          '.uh-live-answers-v2-text-body ol, .uh-live-answers-v2-text-body ul':
            {
              margin: 0,
              paddingLeft: 'medium',
            },
          '.uh-live-answers-v2-text-body ol li': {
            paddingLeft: 0,
          },
          '.uh-live-answers-v2-text-body li': {
            marginBottom: '12px',
            fontSize: '14px',
            fontWeight: 400,
            lineHeight: '20px',
            color: '#30313d',
          },
          '.uh-live-answers-v2-text-body pre': {
            backgroundColor: '#ffffff',
            border: '1px solid #e5e7eb',
          },
          '.uh-live-answers-v2-text-body li:first-of-type': {
            marginTop: 0,
          },
          '.uh-live-answers-v2-text-body li:last-of-type': {
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body li ol, .uh-live-answers-v2-text-body li ul':
            {
              marginLeft: 0,
              marginTop: '4px',
            },
          '.uh-live-answers-v2-text-body li li': {
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body li p': {
            marginBottom: '8px',
          },
          '.uh-live-answers-v2-text-body li p:first-of-type': {
            marginTop: 0,
          },
          '.uh-live-answers-v2-text-body li p:last-of-type': {
            marginBottom: 0,
          },
          '.uh-live-answers-v2-text-body h1, .uh-live-answers-v2-text-body h2, .uh-live-answers-v2-text-body h3, .uh-live-answers-v2-text-body h4, .uh-live-answers-v2-text-body h5, .uh-live-answers-v2-text-body h6':
            {
              fontWeight: 600,
              fontSize: '15px',
              color: '#30313d',
              margin: 0,
            },
          '.uh-live-answers-v2-text-body hr': {
            border: 'none',
            borderTop: '1px solid #e5e7eb',
            margin: 0,
          },
          '.uh-live-answers-v2-text-body blockquote': {
            borderLeft: '3px solid #5469D4',
            margin: 0,
            paddingLeft: 'medium',
          },
          '.uh-live-answers-v2-text-body table': {
            borderCollapse: 'collapse',
            margin: '12px 0',
            fontSize: '13px',
            display: 'block',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            borderSpacing: 0,
            backgroundColor: '#ffffff',
          },
          '.uh-live-answers-v2-text-body thead': {
            borderBottom: '1px solid #e5e7eb',
          },
          '.uh-live-answers-v2-text-body th': {
            padding: '10px 16px',
            textAlign: 'left',
            fontWeight: 600,
            fontSize: '13px',
            color: '#30313d',
            whiteSpace: 'nowrap',
            backgroundColor: 'transparent',
          },
          '.uh-live-answers-v2-text-body td': {
            padding: '12px 16px',
            textAlign: 'left',
            borderTop: '1px solid #e5e7eb',
            whiteSpace: 'nowrap',
            color: '#30313d',
          },
          '.uh-live-answers-v2-text-body tr:first-child td': {
            borderTop: 'none',
          },
        }),
      ]}
      // nosemgrep: no-react-dangerouslysetinnerhtml
      dangerouslySetInnerHTML={{__html: renderFn(body)}} // eslint-disable-line react/no-danger
    />
  );
});
